import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  { label: "Privacy", to: "/privacy", testid: "footer-privacy-link" },
  { label: "Terms", to: "/terms", testid: "footer-terms-link" },
  {
    label: "Accessibility",
    to: "/accessibility",
    testid: "footer-accessibility-link",
  },
];

export default function Footer() {
  return (
    <footer
      className="bg-brand-teal text-white"
      data-testid="site-footer"
    >
      <div className="symp-container flex flex-col gap-10 py-14 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="inline-block rounded-2xl bg-brand-cream px-4 py-2.5">
            <img
              src="/images/logo.png"
              alt="SympTrack, Powered by MyRelief"
              width="1536"
              height="864"
              className="h-auto w-[210px]"
              data-testid="footer-logo"
            />
          </div>
          <p
            className="mt-5 text-[15px] font-semibold text-white/85"
            data-testid="footer-copyright"
          >
            &copy; 2026 SympTrack. All rights reserved. SympTrack&trade;
          </p>
        </div>
        <nav aria-label="Legal" className="md:text-right">
          <ul className="flex flex-wrap gap-6 md:justify-end">
            {LEGAL_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={link.testid}
                  className="text-[15px] font-semibold text-white/80 underline-offset-4 transition-colors hover:text-white hover:underline"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <a
            href="mailto:symptrackhealth@gmail.com"
            data-testid="footer-email-link"
            className="mt-5 inline-block text-[15px] font-semibold text-white/80 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            symptrackhealth@gmail.com
          </a>
        </nav>
      </div>
    </footer>
  );
}
